import React from 'react';

function CustomerNameField({ data }) {
  if (
    data.customerType === 'customerExtra' &&
    data.customer?.type === 'AZIENDA'
  ) {
    return <>{data.customer.businessName}</>;
  } else if (
    data.customerType === 'customerExtra' &&
    data.customer?.type === 'PRIVATO'
  ) {
    return (
      <>
        {data.customer.name} {data.customer.surname}
      </>
    );
  } else if (data.customerType === 'condos') {
    return <>{data.customer?.name}</>;
  } else {
    return <>-</>;
  }
}

export default CustomerNameField;
